import { render, staticRenderFns } from "./Box16.vue?vue&type=template&id=51011fa0&scoped=true&"
import script from "./Box16.vue?vue&type=script&lang=js&"
export * from "./Box16.vue?vue&type=script&lang=js&"
import style0 from "./Box16.vue?vue&type=style&index=0&id=51011fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51011fa0",
  null
  
)

export default component.exports